import { Control } from "../Control.js";

export class Text extends Control {

    constructor(parent, options = {}) {

        super(parent, options);

        const {
            role = Text.Roles.Text,
            text = null,
            content = null,
        } = options;

        if (!(text || content))
            throw new Error('[Text] Options error: "text" or "content" is required.');
        if (text && content)
            throw new Error('[Text] Options error: "text" or "content" is required but not both.');

        this.role = role;
        this.text = text;
        this.content = content;

    };

    static Roles = Object.freeze({
        Text: 'text',
        Span: 'span',
        Paragraph: 'paragraph',
    });

    getText() {

        return (typeof this.text === 'function') ? this.text.call(this) : this.text;

    };

    _render(r, vm) {

        if (!this.isVisible())
            return null;

        const renderer = r;

        var t = this.getText(),
            style = this.getCss();

        if (!style)
            return t;

        return renderer.el('span', style, null, [t]);

    };

}